import './App.css';
import Navigation from "./routes/navigation"

function App() {
  const APP_VERSION = "1.2.0";

  const savedVersion = localStorage.getItem("app_version");

  if (savedVersion !== APP_VERSION) {
    localStorage.clear();
    sessionStorage.clear();
    localStorage.setItem("app_version", APP_VERSION);
    window.location.reload();
  }

  return <Navigation />
}

export default App;
